import {
  ActionJob,
  ActionJobDetails,
  ActionJobForm,
} from "@/interfaces/ActionJob";
import api from "./api";

export const actionJobsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getActionJobs: build.query<ActionJob[], void>({
      query: () => "/action-jobs",
      providesTags: [{ type: "ActionJobs", id: "LIST" }],
    }),
    getActionJob: build.query<ActionJobDetails, string>({
      query: (id) => `/action-jobs/${id}`,
      providesTags: (_result, _error, id) => [{ type: "ActionJobs", id }],
    }),
    createActionJob: build.mutation<ActionJob, ActionJobForm>({
      query: (body) => ({ url: "/action-jobs", method: "POST", body }),
      invalidatesTags: [{ type: "ActionJobs", id: "LIST" }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: job } = await queryFulfilled;
          //* Les lignes disparaissent du tableau sans attendre le polling suivant
          dispatch(
            actionJobsApi.util.updateQueryData(
              "getActionJobs",
              undefined,
              (draft) => {
                draft.unshift(job);
              },
            ),
          );
        } catch {
          //* L'appelant affiche l'erreur
        }
      },
    }),
    markActionJobsSeen: build.mutation<void, void>({
      query: () => ({ url: "/action-jobs/seen", method: "POST" }),
      invalidatesTags: [{ type: "ActionJobs", id: "LIST" }],
    }),
  }),
});

export const {
  useGetActionJobsQuery,
  useLazyGetActionJobQuery,
  useCreateActionJobMutation,
  useMarkActionJobsSeenMutation,
} = actionJobsApi;
